import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PieChartIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.49634 1.80647C8.95044 1.72248 8.5 2.17829 8.5 2.7306V7.2306C8.5 7.78291 8.94775 8.2306 9.5 8.2306H14C14.5522 8.2306 15.0081 7.78016 14.9241 7.23432C14.4946 4.44221 12.2883 2.23597 9.49634 1.80647Z"
		/>
		<path
			fill="currentColor"
			d="M14.6721 10.8537C14.8567 10.2737 14.3845 9.73054 13.7759 9.73054H8C7.44775 9.73054 7 9.28279 7 8.73054V2.9546C7 2.34602 6.45679 1.87391 5.87671 2.0583C3.04883 2.95741 1 5.60469 1 8.73054C1 12.5965 4.13403 15.7305 8 15.7305C11.1257 15.7305 13.7732 13.6817 14.6721 10.8537Z"
		/>
	</svg>
))
